import { styled, alpha } from "@mui/material/styles";
import { Box } from "@mui/material";

const StyledBox = styled(Box)(({ theme }) => ({
    backgroundColor: `${alpha(theme.palette.secondary.dark, 0.7)}`,

}));

export default StyledBox;
